<div>
  <div class="mat-h3">
    Export-Optionen
  </div>
  <p>
    Diese Optionen legen fest, wie die Buchungsdateien für die Schnittstelle generiert werden.
  </p>
  <ul>
    <li>
      <div class="mat-h3">
        Journal exportieren
      </div>
      <p>
        Bestimmt, ob eine Buchungszusammenfassung exportiert wird. Ist diese Option aktiviert, wird eine CSV-Datei mit
        einer Übersicht der Buchungen erstellt und pro Export mitgeliefert.
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Rechnungsexport als CSV
      </div>
      <p>
        Bestimmt, ob die Rechnungen exportiert werden. Ist diese Option aktiviert, wird eine CSV-Datei jeder Rechnung
        erstellt und pro Export mitgeliefert. Der Export muss je Kostenträger aktiviert werden.
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Monats-Datei-Export
      </div>
      <p>
        Standardmäßig wird eine Buchungsdatei für das gesamte Jahr erstellt. Ist der Monats-Datei-Export aktiviert,
        wird für jeden Monat eine separate Buchungsdatei generiert.
      </p>
    </li>
  </ul>
</div>
